import type * as Types from 'app/types/graphql';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ThemePagePublishMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  forcePublish?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type ThemePagePublishMutationResponse = Pick<Types.Mutation, 'themePagePublish'>;

export const ThemePagePublishDocument = `
    mutation ThemePagePublish($id: ID!, $forcePublish: Boolean) {
  themePagePublish(id: $id, forcePublish: $forcePublish)
}
    `;

export const useThemePagePublishMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ThemePagePublishMutationResponse,
    TError,
    ThemePagePublishMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ThemePagePublishMutationResponse,
    TError,
    ThemePagePublishMutationVariables,
    TContext
  >(
    ['ThemePagePublish'],
    (variables?: ThemePagePublishMutationVariables) =>
      appFetcher<ThemePagePublishMutationResponse, ThemePagePublishMutationVariables>(
        ThemePagePublishDocument,
        variables,
      )(),
    options,
  );
};

useThemePagePublishMutation.getKey = () => ['ThemePagePublish'];
